import { Box, Typography } from '@mui/material';
import { numSx } from './numberStyles';

interface FigureProps {
    label: string;
    value: string;
    sub?: string;
    color?: string;
    subColor?: string;
    dense?: boolean;
    title?: string;
}

const clipSx = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
} as const;

export function Figure({
    label,
    value,
    sub,
    color,
    subColor,
    dense = false,
    title,
}: FigureProps) {
    const small = dense ? '10px' : '11px';
    return (
        <Box title={title} sx={{ minWidth: 0 }}>
            <Typography
                sx={{
                    fontSize: small,
                    color: 'text.secondary',
                    whiteSpace: 'nowrap',
                    ...(dense && { ...clipSx, lineHeight: '14px' }),
                }}
            >
                {label}
            </Typography>
            <Typography
                sx={{
                    fontSize: dense ? '13px' : '15px',
                    fontWeight: dense ? 700 : 600,
                    color,
                    whiteSpace: 'nowrap',
                    ...numSx,
                    ...(dense && { ...clipSx, lineHeight: '18px' }),
                }}
            >
                {value}
            </Typography>
            <Typography
                sx={{
                    fontSize: small,
                    color: subColor ?? 'text.secondary',
                    whiteSpace: 'nowrap',
                    ...(dense && { ...clipSx, lineHeight: '14px', ...numSx }),
                }}
            >
                {sub ?? ' '}
            </Typography>
        </Box>
    );
}
